import { Navigate, Route, Routes } from "react-router-dom";

import { canReachPayoutBatches } from "@/app/auth/canReachPayoutBatches";
import { useAuth } from "@/modules/auth/hooks/useAuth";
import { NoAccessView } from "@/shared/components/NoAccessView";

import PayoutBatchCreatePage from "./pages/PayoutBatchCreatePage";
import PayoutBatchDetailPage from "./pages/PayoutBatchDetailPage";
import PayoutBatchesListPage from "./pages/PayoutBatchesListPage";
import { PAYOUT_BATCHES_PATH } from "./utils/batchLinks";

/** The registry's `enabled` flag only hides the menu item, so the organization switch is enforced here too. */
export const PayoutBatchesNavigation = () => {
  const { user } = useAuth();
  if (!canReachPayoutBatches(user)) return <NoAccessView />;

  return (
    <Routes>
      <Route index element={<PayoutBatchesListPage />} />
      <Route path="new" element={<PayoutBatchCreatePage />} />
      <Route path=":id" element={<PayoutBatchDetailPage />} />
      <Route path="*" element={<Navigate to={PAYOUT_BATCHES_PATH} replace />} />
    </Routes>
  );
};
